export const CARDS = [
  { key: "textiles", title: "Textile & Garment Mills", sub: "Spinning, weaving & stitching lines", img: "/images/textiles.jpg", span: "lg:col-span-7 lg:row-span-2", tall: true },
  { key: "factories", title: "Manufacturing & Electronics", sub: "AC & appliance plants", img: "/images/assembly.jpg", span: "lg:col-span-5" },
  { key: "warehousing", title: "Warehousing & Logistics", sub: "Loaders, pickers & forklift staff", img: "/images/warehouse.jpg", span: "lg:col-span-5" },
];

const TEXT_CARDS = [
  { key: "malls", title: "Shopping Malls & Retail Chains", desc: "Guards, housekeeping, trolley staff" },
  { key: "multiplex", title: "Multiplexes & Cinemas", desc: "Bouncers, ushers, helpers" },
  { key: "construction", title: "Construction & Infrastructure", desc: "Site security, welders, loaders" },
];

export const Industries = () => (
  <section id="industries" className="scroll-mt-20 border-t border-white/5 bg-[#0B1120] py-20 lg:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div className="max-w-2xl">
          <p className="eyebrow">Industries served</p>
          <h2 className="mt-4 font-heading text-3xl font-bold tracking-tight text-white lg:text-4xl">Built for high-headcount sites.</h2>
        </div>
        <p className="max-w-sm text-slate-400">From a 20-guard mall rota to a 500-employee garment line — one requirement form covers it.</p>
      </div>
      <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-12">
        <article data-testid="industry-card-security" className="group relative h-72 overflow-hidden rounded-2xl shadow-md md:col-span-2 lg:col-span-12">
          <img src="/images/guard.png" alt="Security guard at a site entrance" className="absolute inset-0 h-full w-full object-cover object-[50%_25%] transition-transform duration-700 group-hover:scale-105" />
          <div className="absolute inset-0" style={{ background: "linear-gradient(to left, rgba(11,27,63,.92) 0%, rgba(11,27,63,.5) 40%, rgba(11,27,63,0) 70%)" }} />
          <div className="absolute bottom-0 right-0 p-6 text-right">
            <h3 className="font-heading text-2xl font-bold text-white">Security for every site</h3>
            <p className="mt-1 inline-block rounded-full bg-orange-500 px-3 py-0.5 text-sm font-medium text-white">Malls, factories, warehouses & offices</p>
          </div>
        </article>
        {TEXT_CARDS.map((c, i) => (
          <article key={c.key} data-testid={`industry-card-${c.key}`} className="rounded-2xl border border-white/10 bg-[#0F172A] p-6 transition-colors hover:border-orange-500/50 lg:col-span-4">
            <span className="rounded-full bg-orange-500 px-2 py-0.5 font-mono text-xs font-bold text-white">0{i + 4}</span>
            <h3 className="mt-3 font-heading text-xl font-bold text-white">{c.title}</h3>
            <p className="mt-2 text-sm text-slate-400">{c.desc}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);
